/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API48749Item {
  
  /** 战役项目编号 */
  projectNo?: string;
  
  /** 战役项目名 */
  name?: string;
  
};
    
  



export interface API48749Req {
  
  /** 项目名称，模糊查询 */
  name?: string;
    
  /** 当前项目编号,（排除当前项目编号） */
  currentProjectNo?: string;
    
  /** 业务分类：1.基础业务2.创新业务3.投资业务 */
  businessType?: string;
    
  /** 类型：1.项目(默认)2.任务 */
  projectType?: string;
    
  /** 是否是主父业务 */
  isMainBusiness?: string;
    
  /** 启用状态：1.启用2.停用 */
  enableStatus?: string;
    
  /**  */
  pageSize?: string;
    
  /**  */
  pageIndex?: string;
    
  /**  */
  rowId?: string;
    
  /**  */
  jumpType?: string;
    
  /**  */
  searchCount?: string;
    
  /**  */
  orderObjects?: string;
    
};



export interface API48749Res {
  /** T  */
  list?: API48749Item[];
  /**   */
  totalNumber?: any;
  /**   */
  totalPage?: any;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: any;
  /**   */
  pageIndex?: any;
  
};


// 48749 获取项目列表  - 下拉列表

export interface IUseGetAPI48749Return {
  /** 获取项目列表  - 下拉列表: 接口请求状态 */
  isAPI48749Loading: boolean;
  /** 获取项目列表  - 下拉列表: 接口请求返回数据 */
  dataAPI48749: API48749Res;
  /**  获取项目列表  - 下拉列表: 接口数据请求方法 */
  fetchAPI48749Data:  (inputs: API48749Req, config?: YWRequestConfig) => Promise<API48749Res>;
  /** 获取项目列表  - 下拉列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI48749 = ():IUseGetAPI48749Return => {
  let isMount = true;
  const [isAPI48749Loading, setIsAPI48749Loading] = useState(false);
  const [dataAPI48749, setDataAPI48749] = useState<API48749Res>({} as API48749Res);
  const requestUrl = `${basePath}/corp-admin/project/list/selected/v1`;

  const fetchAPI48749Data = async (inputs: API48749Req, config?: YWRequestConfig): Promise<API48749Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API48749Req>) || {}) as API48749Req;
    
  
    if ( isMount ) {
      setIsAPI48749Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API48749Res>(`${basePath}/corp-admin/project/list/selected/v1?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI48749(res || {} as API48749Res);
        setIsAPI48749Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI48749Loading(false);
      }
      return false as unknown as API48749Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI48749Loading,
    dataAPI48749,
    fetchAPI48749Data,
    requestUrl,
  }
}

